import { useEffect, useState } from 'react';
import './App.css';

const EXPERIENCE_STATS = [
  { label: 'Taxi Units', value: 100 },
  { label: 'Years Experience', value: 87, isFeatured: true },
  { label: 'Happy Clients', value: 100 },
  { label: 'Membership', value: 100 },
];

const AIRPORTS = [
  {
    name: 'Heathrow Airport (LHR)',
    desc: 'TAXI-247 provides reliable and comfortable transfer services to and from Heathrow Airport, ensuring a smooth and stress-free journey. TAXI-247 focuses on punctual pickups, professional drivers, and well-maintained vehicles for a premium travel experience. Whether traveling for business or leisure, TAXI-247 guarantees dependable airport transportation.',
  },
  {
    name: 'Gatwick Airport (LGW)',
    desc: 'TAXI-247 offers efficient and timely taxi services to and from Gatwick Airport, making travel simple and convenient. TAXI-247 ensures safe journeys with experienced drivers and comfortable vehicles. Passengers can rely on TAXI-247 for hassle-free airport transfers every time.',
  },
  {
    name: 'Manchester Airport (MAN)',
    desc: 'TAXI-247 provides professional airport transfer services to Manchester Airport with a focus on comfort and reliability. TAXI-247 ensures on-time pickups and smooth travel for all passengers. Enjoy a relaxed journey with TAXI-247.',
  },
  {
    name: 'Stansted Airport (STN)',
    desc: 'TAXI-247 delivers dependable transfer services to Stansted Airport, ensuring timely and stress-free travel. TAXI-247 uses experienced drivers and modern vehicles for a comfortable ride. Travel confidently with TAXI-247.',
  },
  {
    name: 'Luton Airport (LTN)',
    desc: 'TAXI-247 offers convenient taxi services to and from Luton Airport with a strong focus on punctuality. TAXI-247 ensures a safe and comfortable journey for every passenger. Choose TAXI-247 for reliable airport transfers.',
  },
  {
    name: 'Birmingham Airport (BHX)',
    desc: 'TAXI-247 provides smooth and efficient transfers to Birmingham Airport, ensuring a comfortable travel experience. TAXI-247 focuses on timely service and customer satisfaction. Passengers can trust TAXI-247 for dependable journeys.',
  },
  {
    name: 'Edinburgh Airport (EDI)',
    desc: 'TAXI-247 offers reliable airport transfers to Edinburgh Airport with a focus on comfort and punctuality. TAXI-247 ensures smooth pickups and drop-offs for all travelers. Enjoy stress-free travel with TAXI-247.',
  },
  {
    name: 'Glasgow Airport (GLA)',
    desc: 'TAXI-247 provides professional transfer services to Glasgow Airport, ensuring safe and timely journeys. TAXI-247 delivers comfort and reliability with experienced drivers. Travel easily with TAXI-247.',
  },
  {
    name: 'Bristol Airport (BRS)',
    desc: 'TAXI-247 offers dependable taxi services to Bristol Airport, making airport travel simple and convenient. TAXI-247 ensures a comfortable and smooth journey. Choose TAXI-247 for reliable transfers.',
  },
  {
    name: 'Newcastle Airport (NCL)',
    desc: 'TAXI-247 provides efficient transfer services to Newcastle Airport, ensuring a stress-free travel experience. TAXI-247 focuses on safety, comfort, and punctuality. Passengers can rely on TAXI-247 every time.',
  },
  {
    name: 'Liverpool John Lennon Airport (LPL)',
    desc: 'TAXI-247 offers reliable airport transfers to Liverpool John Lennon Airport with a focus on comfort and convenience. TAXI-247 ensures smooth and timely travel. Enjoy hassle-free journeys with TAXI-247.',
  },
  {
    name: 'East Midlands Airport (EMA)',
    desc: 'TAXI-247 provides professional taxi services to East Midlands Airport, ensuring safe and timely transportation. TAXI-247 focuses on delivering a smooth and comfortable experience. Travel with confidence using TAXI-247.',
  },
  {
    name: 'Aberdeen Airport (ABZ)',
    desc: 'TAXI-247 offers long-distance airport transfer services to Aberdeen Airport with comfort and reliability. TAXI-247 ensures a safe and relaxing journey for all passengers. Trust TAXI-247 for dependable travel.',
  },
  {
    name: 'Belfast International Airport (BFS)',
    desc: 'TAXI-247 provides efficient and reliable transfers to Belfast International Airport, ensuring a smooth travel experience. TAXI-247 focuses on punctual service and passenger comfort. Choose TAXI-247 for stress-free journeys.',
  },
  {
    name: 'London City Airport (LCY)',
    desc: 'TAXI-247 offers convenient taxi services to London City Airport with a focus on speed and reliability. TAXI-247 ensures timely pickups and comfortable rides. Travel easily with TAXI-247.',
  },
];

const SERVICES = [
  {
    title: 'Airport Transfers',
    img: 'Airport Transfers.jpg',
    desc: 'TAXI-247 provides reliable and on-time airport transfer services in Edinburgh, ensuring passengers reach their destination without any stress or delay. TAXI-247 focuses on comfort, punctuality, and a smooth travel experience for both arrivals and departures. With professional drivers, well-maintained vehicles, and real-time flight tracking, TAXI-247 makes airport journeys easy, safe, and dependable for every traveler.',
  },
  {
    title: 'Free Child & Baby Seats',
    img: 'Free Child & Baby Seats.jpg',
    desc: 'TAXI-247 offers free child and baby seat facilities in Edinburgh to ensure safe and secure travel for families with young children. TAXI-247 prioritizes passenger safety by providing properly fitted seats for infants and kids of all ages. Families can enjoy comfortable and worry-free journeys knowing TAXI-247 takes extra care of their safety needs.',
  },
  {
    title: 'Meet & Greet Service',
    img: 'Meet & Greet Service.jpg',
    desc: 'TAXI-247 provides a professional meet & greet service at Edinburgh airport where drivers warmly welcome passengers upon arrival. TAXI-247 assists with luggage handling and guides passengers smoothly to their vehicles without any confusion. This service ensures a stress-free, friendly, and welcoming airport experience with TAXI-247.',
  },
  {
    title: '24/7 Taxi Service',
    img: '247 Taxi Service.jfif',
    desc: 'TAXI-247 operates a 24/7 taxi service in Edinburgh, allowing passengers to book rides at any time of the day or night. TAXI-247 ensures that transportation is always available, whether it\'s early morning or late night travel. With round-the-clock service and quick response times, TAXI-247 provides maximum convenience and reliability.',
  },
  {
    title: 'Executive & Business Travel',
    img: 'Executive & Business Travel.webp',
    desc: 'TAXI-247 offers premium executive and business travel services in Edinburgh designed for corporate clients and professionals. TAXI-247 ensures privacy, comfort, and high-quality service for meetings, conferences, and official trips. Business travelers rely on TAXI-247 for punctual, smooth, and professional travel experiences every time.',
  },
  {
    title: 'City-to-City Transfers',
    img: 'City-to-City Transfers.jpg',
    desc: 'TAXI-247 provides reliable city-to-city transfer services from Edinburgh, making intercity travel simple, smooth, and comfortable. TAXI-247 ensures safe long-distance journeys with experienced drivers and well-maintained vehicles. Passengers can travel between cities with confidence, enjoying a relaxed and hassle-free ride.',
  },
  {
    title: 'Minibus & Group Travel',
    img: 'Minibus & Group Travel.jpg',
    desc: 'TAXI-247 offers spacious minibus and group travel services in Edinburgh, perfect for families, events, and group tours. TAXI-247 provides comfortable seating, extra space, and convenience for multiple passengers and luggage. Group travel becomes easy, organized, and enjoyable with TAXI-247.',
  },
  {
    title: 'Wheelchair Accessible Vehicles',
    img: 'Wheelchair Accessible.webp',
    desc: 'TAXI-247 provides wheelchair accessible vehicles in Edinburgh to ensure inclusive and comfortable travel for all passengers. TAXI-247 is committed to supporting passengers with mobility needs through specially designed and equipped vehicles. Everyone can travel safely, comfortably, and independently with TAXI-247.',
  },
  {
    title: 'Pet-Friendly Taxi Service',
    img: 'Pet-Friendly Service.jpg',
    desc: 'TAXI-247 offers pet-friendly taxi services in Edinburgh, allowing passengers to travel with their pets comfortably. TAXI-247 ensures a safe, clean, and relaxed environment for both passengers and their furry companions. Pet owners can travel easily without any worries using TAXI-247.',
  },
  {
    title: 'Courier & Parcel Delivery',
    img: 'Courier & Parcel Delivery.webp',
    desc: 'TAXI-247 provides fast and secure courier and parcel delivery services in Edinburgh for both personal and business needs. TAXI-247 ensures safe handling and timely delivery of packages across the city. Customers trust TAXI-247 for quick, reliable, and efficient delivery solutions.',
  },
  {
    title: 'Long Distance Journeys',
    img: 'Long Distance Journeys.webp',
    desc: 'TAXI-247 offers long-distance travel services from Edinburgh with comfort and safety as top priorities. TAXI-247 uses experienced drivers to ensure smooth and enjoyable journeys over long routes. Passengers can relax and enjoy stress-free travel with dependable service.',
  },
  {
    title: 'Easy Online Booking',
    img: 'Easy Online Booking.png',
    desc: 'TAXI-247 provides an easy online booking system in Edinburgh, making ride reservations quick and simple. TAXI-247 allows customers to book taxis within minutes through a user-friendly platform. Convenience, speed, and ease of use are the main focus of TAXI-247.',
  },
  {
    title: 'Secure Online Payments',
    img: 'Secure Online Payments.jpg',
    desc: 'TAXI-247 supports secure online payment options in Edinburgh for safe and hassle-free transactions. TAXI-247 ensures all payments are protected with advanced security systems and encryption. Customers can pay easily and confidently without any concerns.',
  },
  {
    title: 'Extra Luggage Transfers',
    img: 'Extra Luggage Transfers.jpg',
    desc: 'TAXI-247 accommodates extra luggage in Edinburgh, making travel easier for passengers with heavy or additional baggage. TAXI-247 provides vehicles with sufficient space to handle all luggage needs comfortably. Passengers can travel stress-free without worrying about space.',
  },
  {
    title: 'Flight Monitoring & Delay Tracking',
    img: 'Flight Monitoring.jpg',
    desc: 'TAXI-247 offers real-time flight monitoring in Edinburgh to adjust pickup times according to delays or early arrivals. TAXI-247 ensures drivers are always updated with flight schedules for smooth coordination. This service guarantees a stress-free and perfectly timed airport pickup experience.',
  },
];

const getAirportSlug = (name) =>
  name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const findAirportBySlug = (slug) =>
  AIRPORTS.find((airport) => getAirportSlug(airport.name) === slug);

const getServiceSlug = (title) =>
  title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const findServiceBySlug = (slug) =>
  SERVICES.find((svc) => getServiceSlug(svc.title) === slug);

function App() {
  const [experienceValues, setExperienceValues] = useState(
    EXPERIENCE_STATS.map(() => 0)
  );
  const [activeHash, setActiveHash] = useState(window.location.hash || '#home');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isAirportDetailsPage = activeHash.startsWith('#/airport-details/');
  const selectedAirportSlug = activeHash.replace('#/airport-details/', '');
  const selectedAirport = findAirportBySlug(selectedAirportSlug);

  const isServiceDetailsPage = activeHash.startsWith('#/service-details/');
  const selectedServiceSlug = activeHash.replace('#/service-details/', '');
  const selectedService = findServiceBySlug(selectedServiceSlug);

  useEffect(() => {
    const durationMs = 1400;
    const steps = 45;
    let currentStep = 0;

    const timer = window.setInterval(() => {
      currentStep += 1;

      setExperienceValues(
        EXPERIENCE_STATS.map((stat) =>
          Math.min(stat.value, Math.round((stat.value * currentStep) / steps))
        )
      );

      if (currentStep >= steps) {
        window.clearInterval(timer);
      }
    }, durationMs / steps);

    return () => window.clearInterval(timer);
  }, []);

  useEffect(() => {
    const handleHashChange = () => {
      setActiveHash(window.location.hash || '#home');
      setIsMenuOpen(false);
    };

    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  useEffect(() => {
    if (
      activeHash.startsWith('#/airport-details/') ||
      activeHash.startsWith('#/service-details/')
    ) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return undefined;
    }

    if (activeHash === '#airport' || activeHash === '#services') {
      const sectionId = activeHash.replace('#', '');
      const timer = window.setTimeout(() => {
        const section = document.getElementById(sectionId);

        if (section) {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 0);

      return () => window.clearTimeout(timer);
    }

    return undefined;
  }, [activeHash]);

  const renderBrandLogo = (isFooter = false) => (
    <span className={`brand-logo-custom ${isFooter ? 'brand-logo-custom-footer' : ''}`} aria-hidden="true">
      <img
        src={`${process.env.PUBLIC_URL}/247-Taxi-Cabs-Logo.webp`}
        alt="TAXI-247"
        className={`brand-logo-img ${isFooter ? 'brand-logo-img-footer' : ''}`}
      />
    </span>
  );

  const heroStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/logo2.png)`,
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  };

  const quickActions = [
    {
      label: 'Call Now',
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 9h6v6H9z" opacity="0" />
          <path d="M9 2h6" />
          <path d="M3 2h6v6H3z" opacity="0" />
          <rect x="3.5" y="3.5" width="13" height="13" rx="1.5" />
          <path d="m7.5 10.2 2.1 2.1 3.9-4.2" />
        </svg>
      ),
      className: 'action-call',
      href: 'tel:02038393300',
    },
    {
      label: 'Get Quotation',
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3.5" y="3.5" width="13" height="13" rx="1.5" />
          <path d="M9.7 6.8h3.6" />
          <path d="M11.5 6.8v6.4" />
          <path d="M9.2 9.6h3.8" />
          <path d="M8.7 12.6h5.7" />
        </svg>
      ),
      className: 'action-quote',
      href: 'https://booktaxinow.co.uk/',
      external: true,
    },
    {
      label: 'Book Now',
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 12h18" />
          <path d="M5 12 6.5 7.8A2.5 2.5 0 0 1 8.85 6h6.3a2.5 2.5 0 0 1 2.35 1.8L19 12" />
          <rect x="4" y="12" width="16" height="6" rx="2" />
          <circle cx="7.5" cy="15" r="1" />
          <circle cx="16.5" cy="15" r="1" />
        </svg>
      ),
      className: 'action-book',
      href: 'https://booktaxinow.co.uk/',
      external: true,
    },
    {
      label: 'Airport Booking',
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3.5" y="3.5" width="13" height="13" rx="1.5" />
          <path d="M12 2.7v3" />
          <path d="M8 2.7v3" />
          <path d="M3.5 8.2h13" />
          <path d="m7.1 11.3 1.7 1.8 3.6-3.7" />
        </svg>
      ),
      className: 'action-airport',
      href: 'https://www.minicabshub-online.co.uk/consumer/#/booking',
      external: true,
    },
  ];

  const renderExperienceBand = (keySuffix) => (
    <section className="experience-band" aria-label="TAXI-247 experience highlights" key={keySuffix}>
      <div className="container">
        <p className="experience-label">Experience</p>
        <h2 className="experience-title">We are experienced since</h2>
        <div className="experience-grid" role="list">
          {EXPERIENCE_STATS.map((stat, index) => (
            <article
              className={`experience-card ${stat.isFeatured ? 'experience-card-featured' : ''}`}
              key={stat.label}
              role="listitem"
            >
              <p className="experience-number">{experienceValues[index]}</p>
              <p className="experience-card-label">{stat.label}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );

  const renderMobileCallStrip = () => (
    <a className="mobile-call-strip" href="tel:02038393300" aria-label="Call 02038393300">
      <span className="mobile-call-strip-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" />
        </svg>
      </span>
      <span>Call Now 02038393300</span>
    </a>
  );

  if (isServiceDetailsPage) {
    return (
      <div className="site-shell airport-details-page">
        <header className="site-header">
          <div className="container header-content">
            <a className="brand" href="#home" aria-label="TAXI-247 home">
              {renderBrandLogo()}
            </a>
            <button
              className="menu-toggle"
              type="button"
              onClick={() => setIsMenuOpen((prev) => !prev)}
              aria-expanded={isMenuOpen}
              aria-label="Toggle menu"
            >
              ☰
            </button>
            <nav className={`main-nav ${isMenuOpen ? 'open' : ''}`} aria-label="Main navigation">
              <a href="#home" onClick={() => setIsMenuOpen(false)}>Home</a>
              <a href="#about" onClick={() => setIsMenuOpen(false)}>About Us</a>
              <a href="#services" onClick={() => setIsMenuOpen(false)}>Our Services</a>
              <a href="#airport" onClick={() => setIsMenuOpen(false)}>Airport Transfers</a>
              <a href="#contact" onClick={() => setIsMenuOpen(false)}>Contact Us</a>
            </nav>
            <a className="header-contact-link" href="#contact">Contact Us</a>
          </div>
        </header>

        <main className="airport-details-main">
          <section className="hero airport-details-home-hero" style={heroStyle}>
            <div className="hero-overlay" />
            <div className="container hero-content">
              <div className="hero-intro">
                <p className="hero-kicker">Trusted 24/7 Transport Service</p>
                <h1 className="hero-title">
                  {selectedService ? selectedService.title : 'Our Services'}
                </h1>
                <p className="hero-subtitle">With TAXI-247, available 24/7.</p>
              </div>
              <div className="quick-actions" role="list">
                {quickActions.map((action) => (
                  <a
                    className={`action-card ${action.className}`}
                    href={action.href}
                    key={action.label}
                    role="listitem"
                    target={action.external ? '_blank' : undefined}
                    rel={action.external ? 'noopener noreferrer' : undefined}
                  >
                    <span className="action-icon">{action.icon}</span>
                    <span className="action-text">{action.label}</span>
                  </a>
                ))}
              </div>
            </div>
          </section>

          <section className="content-section">
            <div className="container">
              <p className="section-tag">Our Services</p>
              <h1 className="airport-details-title">
                {selectedService ? selectedService.title : 'Service Not Found'}
              </h1>
              <a className="airport-back-btn" href="#services">Back To Services</a>
              <div className="svc-details-layout">
                {selectedService ? (
                  <>
                    <div className="svc-details-img-wrap">
                      <img
                        src={`${process.env.PUBLIC_URL}/images/${encodeURIComponent(selectedService.img)}`}
                        alt={selectedService.title}
                        className="svc-details-img"
                      />
                    </div>
                    <div className="svc-details-body">
                      <p>{selectedService.desc}</p>
                    </div>
                  </>
                ) : (
                  <p>The selected service could not be found. Please return to Our Services and choose again.</p>
                )}
              </div>
            </div>
          </section>

          <section className="content-section contact" id="contact">
            <div className="container">
              <p className="section-tag">Contact Us</p>
              <h2>Need help booking this service?</h2>
              <div className="contact-panel">
                <div className="contact-primary">
                  <div className="contact-call-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24">
                      <path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" />
                    </svg>
                  </div>
                  <div className="contact-main-copy">
                    <p className="contact-support-line">We are open 24 hours throughout the year.</p>
                    <a className="contact-phone-link" href="tel:02038393300">Call us anytime at 02038393300</a>
                    <p className="contact-note">Fast support for instant booking and custom quotes.</p>
                  </div>
                </div>
                <div className="contact-methods">
                  <article className="contact-method-card">
                    <span className="contact-method-label">Call</span>
                    <a href="tel:02038393300">02038393300</a>
                  </article>
                  <article className="contact-method-card">
                    <span className="contact-method-label">Email</span>
                    <a href="mailto:info@taxi-247.co.uk">info@taxi-247.co.uk</a>
                  </article>
                  <article className="contact-method-card">
                    <span className="contact-method-label">WhatsApp</span>
                    <a href="https://wa.me/447365874733" target="_blank" rel="noopener noreferrer">07365874733</a>
                  </article>
                  <article className="contact-method-card">
                    <span className="contact-method-label">Address</span>
                    <p>UK</p>
                  </article>
                </div>
              </div>
            </div>
          </section>
        </main>

        {renderMobileCallStrip()}

        <div className="floating-contact" aria-label="Quick contact actions">
          <a className="floating-btn floating-whatsapp" href="https://wa.me/447365874733" target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12.04 2C6.6 2 2.2 6.3 2.2 11.62c0 1.96.6 3.78 1.64 5.3L2 22l5.27-1.73a10.03 10.03 0 0 0 4.77 1.2h.01c5.43 0 9.84-4.3 9.84-9.63C21.89 6.3 17.48 2 12.04 2Zm0 17.63c-1.5 0-2.98-.4-4.26-1.17l-.3-.18-3.13 1.03 1.03-3.03-.2-.31a7.53 7.53 0 0 1-1.2-4.05c0-4.17 3.47-7.57 7.75-7.57 4.27 0 7.75 3.4 7.75 7.57 0 4.18-3.47 7.57-7.74 7.57Zm4.14-5.66c-.22-.1-1.31-.64-1.52-.71-.2-.08-.35-.1-.5.1-.15.22-.58.7-.7.84-.13.16-.26.18-.48.06-.22-.1-.94-.34-1.78-1.08-.66-.58-1.1-1.3-1.23-1.52-.13-.22-.01-.33.1-.44.1-.1.22-.26.33-.39.11-.12.15-.22.23-.36.08-.16.03-.28-.02-.4-.05-.1-.5-1.2-.68-1.65-.18-.42-.36-.36-.5-.37h-.43c-.15 0-.39.06-.59.28-.2.22-.78.76-.78 1.85 0 1.1.8 2.15.92 2.3.11.14 1.55 2.44 3.86 3.32.55.24.98.39 1.31.5.55.18 1.04.16 1.43.1.43-.06 1.31-.53 1.5-1.04.2-.5.2-.94.14-1.04-.06-.1-.2-.16-.43-.26Z" />
            </svg>
          </a>
          <a className="floating-btn floating-call" href="tel:+442038393300" aria-label="Call now">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" />
            </svg>
          </a>
        </div>

        <footer className="site-footer">
          <div className="footer-top">
            <div className="container footer-grid">
              <div className="footer-brand-block">
                <a className="brand footer-brand-link" href="#home" aria-label="TAXI-247 home">
                  {renderBrandLogo(true)}
                </a>
                <p>Professional taxi and airport transfer service focused on safety, punctuality, and comfort.</p>
                <div className="footer-social-row">
                  <a className="footer-social-btn" href="tel:02038393300" aria-label="Call us">
                    <svg viewBox="0 0 24 24"><path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" /></svg>
                  </a>
                  <a className="footer-social-btn" href="https://wa.me/447365874733" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                    <svg viewBox="0 0 24 24"><path d="M12.04 2C6.6 2 2.2 6.3 2.2 11.62c0 1.96.6 3.78 1.64 5.3L2 22l5.27-1.73a10.03 10.03 0 0 0 4.77 1.2h.01c5.43 0 9.84-4.3 9.84-9.63C21.89 6.3 17.48 2 12.04 2Z" /></svg>
                  </a>
                  <a className="footer-social-btn" href="mailto:info@taxi-247.co.uk" aria-label="Email us">
                    <svg viewBox="0 0 24 24"><path d="M3 6h18v12H3V6Zm2 2v.2l7 4.8 7-4.8V8l-7 4.8L5 8Z" /></svg>
                  </a>
                </div>
              </div>
              <div className="footer-link-group">
                <h4>Quick Links</h4>
                <a href="#home">Home</a>
                <a href="#about">About Us</a>
                <a href="#services">Our Services</a>
                <a href="#airport">Airport Transfers</a>
                <a href="#contact">Contact Us</a>
              </div>
              <div className="footer-link-group">
                <h4>Contact</h4>
                <a className="footer-contact-item" href="mailto:info@taxi-247.co.uk">
                  <span className="footer-contact-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24"><path d="M3 6h18v12H3V6Zm2 2v.2l7 4.8 7-4.8V8l-7 4.8L5 8Z" /></svg>
                  </span>
                  <span>info@taxi-247.co.uk</span>
                </a>
                <a className="footer-contact-item" href="tel:02038393300">
                  <span className="footer-contact-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24"><path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" /></svg>
                  </span>
                  <span>02038393300</span>
                </a>
                <a className="footer-contact-item" href="https://wa.me/447365874733" target="_blank" rel="noopener noreferrer">
                  <span className="footer-contact-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24"><path d="M12.04 2C6.6 2 2.2 6.3 2.2 11.62c0 1.96.6 3.78 1.64 5.3L2 22l5.27-1.73a10.03 10.03 0 0 0 4.77 1.2h.01c5.43 0 9.84-4.3 9.84-9.63C21.89 6.3 17.48 2 12.04 2Z" /></svg>
                  </span>
                  <span>07365874733</span>
                </a>
              </div>
              <div className="footer-link-group">
                <h4>Working Hours</h4>
                <p className="footer-hours-item">
                  <span className="footer-hours-day">Mon – Fri</span>
                  <span className="footer-hours-time">24 / 7</span>
                </p>
                <p className="footer-hours-item">
                  <span className="footer-hours-day">Saturday</span>
                  <span className="footer-hours-time">24 / 7</span>
                </p>
                <p className="footer-hours-item">
                  <span className="footer-hours-day">Sunday</span>
                  <span className="footer-hours-time">24 / 7</span>
                </p>
                <p className="footer-hours-item">
                  <span className="footer-hours-day">Holidays</span>
                  <span className="footer-hours-time">Open</span>
                </p>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="container footer-bottom-inner">
              <p className="copyright">
                © {new Date().getFullYear()} <span className="copyright-brand">TAXI-247</span>. All rights reserved.
              </p>
              <div className="footer-bottom-links">
                <a href="#home">Privacy Policy</a>
                <a href="#home">Terms of Service</a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }

  if (isAirportDetailsPage) {
    return (
      <div className="site-shell airport-details-page">
        <header className="site-header">
          <div className="container header-content">
            <a className="brand" href="#home" aria-label="TAXI-247 home">
              {renderBrandLogo()}
            </a>
            <button
              className="menu-toggle"
              type="button"
              onClick={() => setIsMenuOpen((prev) => !prev)}
              aria-expanded={isMenuOpen}
              aria-label="Toggle menu"
            >
              ☰
            </button>
            <nav className={`main-nav ${isMenuOpen ? 'open' : ''}`} aria-label="Main navigation">
              <a href="#home" onClick={() => setIsMenuOpen(false)}>Home</a>
              <a href="#about" onClick={() => setIsMenuOpen(false)}>About Us</a>
              <a href="#services" onClick={() => setIsMenuOpen(false)}>Our Services</a>
              <a href="#airport" onClick={() => setIsMenuOpen(false)}>Airport Transfers</a>
              <a href="#contact" onClick={() => setIsMenuOpen(false)}>Contact Us</a>
            </nav>
            <a className="header-contact-link" href="#contact">Contact Us</a>
          </div>
        </header>

        <main className="airport-details-main">
          <section
            className="hero airport-details-home-hero"
            style={heroStyle}
          >
            <div className="hero-overlay" />
            <div className="container hero-content">
              <div className="hero-intro">
                <p className="hero-kicker">Trusted 24/7 Transport Service</p>
                <h1 className="hero-title">
                  {selectedAirport
                    ? selectedAirport.name
                    : 'Book Reliable Airport Transfers & Taxi Rides'}
                </h1>
                <p className="hero-subtitle">With TAXI-247, available 24/7.</p>
              </div>
              <div className="quick-actions" role="list">
                {quickActions.map((action) => (
                  <a
                    className={`action-card ${action.className}`}
                    href={action.href}
                    key={action.label}
                    role="listitem"
                    target={action.external ? '_blank' : undefined}
                    rel={action.external ? 'noopener noreferrer' : undefined}
                  >
                    <span className="action-icon">{action.icon}</span>
                    <span className="action-text">{action.label}</span>
                  </a>
                ))}
              </div>
            </div>
          </section>

          <section className="content-section">
            <div className="container">
              <p className="section-tag">Airport Transfers</p>
              <h1 className="airport-details-title">
                {selectedAirport ? selectedAirport.name : 'Airport Not Found'}
              </h1>
              <a className="airport-back-btn" href="#airport">Back To Airport List</a>
              <div className="airport-details-list">
                {selectedAirport ? (
                  <article className="airport-details-item" key={selectedAirport.name}>
                    <h2>{selectedAirport.name}</h2>
                    <p>{selectedAirport.desc}</p>
                  </article>
                ) : (
                  <article className="airport-details-item">
                    <h2>Details unavailable</h2>
                    <p>
                      The selected airport could not be found. Please return to
                      the airport transfers section and choose an airport again.
                    </p>
                  </article>
                )}
              </div>
            </div>
          </section>

          <section className="content-section contact" id="contact">
            <div className="container">
              <p className="section-tag">Contact Us</p>
              <h2>Need airport booking assistance?</h2>
              <div className="contact-panel">
                <div className="contact-primary">
                  <div className="contact-call-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24">
                      <path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" />
                    </svg>
                  </div>
                  <div className="contact-main-copy">
                    <p className="contact-support-line">We are open 24 hours throughout the year.</p>
                    <a className="contact-phone-link" href="tel:02038393300">Call us anytime at 02038393300</a>
                    <p className="contact-note">Fast support for instant booking and custom quotes.</p>
                  </div>
                </div>

                <div className="contact-methods">
                  <article className="contact-method-card">
                    <span className="contact-method-label">Call</span>
                    <a href="tel:02038393300">02038393300</a>
                  </article>
                  <article className="contact-method-card">
                    <span className="contact-method-label">Email</span>
                    <a href="mailto:info@taxi-247.co.uk">info@taxi-247.co.uk</a>
                  </article>
                  <article className="contact-method-card">
                    <span className="contact-method-label">WhatsApp</span>
                    <a href="https://wa.me/447365874733" target="_blank" rel="noopener noreferrer">07365874733</a>
                  </article>
                  <article className="contact-method-card">
                    <span className="contact-method-label">Address</span>
                    <p>UK</p>
                  </article>
                </div>
              </div>
            </div>
          </section>
        </main>

        {renderMobileCallStrip()}

        <div className="floating-contact" aria-label="Quick contact actions">
          <a
            className="floating-btn floating-whatsapp"
            href="https://wa.me/447365874733"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12.04 2C6.6 2 2.2 6.3 2.2 11.62c0 1.96.6 3.78 1.64 5.3L2 22l5.27-1.73a10.03 10.03 0 0 0 4.77 1.2h.01c5.43 0 9.84-4.3 9.84-9.63C21.89 6.3 17.48 2 12.04 2Zm0 17.63c-1.5 0-2.98-.4-4.26-1.17l-.3-.18-3.13 1.03 1.03-3.03-.2-.31a7.53 7.53 0 0 1-1.2-4.05c0-4.17 3.47-7.57 7.75-7.57 4.27 0 7.75 3.4 7.75 7.57 0 4.18-3.47 7.57-7.74 7.57Zm4.14-5.66c-.22-.1-1.31-.64-1.52-.71-.2-.08-.35-.1-.5.1-.15.22-.58.7-.7.84-.13.16-.26.18-.48.06-.22-.1-.94-.34-1.78-1.08-.66-.58-1.1-1.3-1.23-1.52-.13-.22-.01-.33.1-.44.1-.1.22-.26.33-.39.11-.12.15-.22.23-.36.08-.16.03-.28-.02-.4-.05-.1-.5-1.2-.68-1.65-.18-.42-.36-.36-.5-.37h-.43c-.15 0-.39.06-.59.28-.2.22-.78.76-.78 1.85 0 1.1.8 2.15.92 2.3.11.14 1.55 2.44 3.86 3.32.55.24.98.39 1.31.5.55.18 1.04.16 1.43.1.43-.06 1.31-.53 1.5-1.04.2-.5.2-.94.14-1.04-.06-.1-.2-.16-.43-.26Z" />
            </svg>
          </a>
          <a
            className="floating-btn floating-call"
            href="tel:+442038393300"
            aria-label="Call now"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" />
            </svg>
          </a>
        </div>

        <footer className="site-footer">
          <div className="footer-top">
            <div className="container footer-grid">
              <div className="footer-brand-block">
                <a className="brand footer-brand-link" href="#home" aria-label="TAXI-247 home">
                  {renderBrandLogo(true)}
                </a>
                <p>
                  Professional taxi and airport transfer service focused on safety,
                  punctuality, and comfort.
                </p>
                <div className="footer-social-row">
                  <a className="footer-social-btn" href="tel:02038393300" aria-label="Call us">
                    <svg viewBox="0 0 24 24"><path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" /></svg>
                  </a>
                  <a className="footer-social-btn" href="https://wa.me/447365874733" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                    <svg viewBox="0 0 24 24"><path d="M12.04 2C6.6 2 2.2 6.3 2.2 11.62c0 1.96.6 3.78 1.64 5.3L2 22l5.27-1.73a10.03 10.03 0 0 0 4.77 1.2h.01c5.43 0 9.84-4.3 9.84-9.63C21.89 6.3 17.48 2 12.04 2Z" /></svg>
                  </a>
                  <a className="footer-social-btn" href="mailto:info@taxi-247.co.uk" aria-label="Email us">
                    <svg viewBox="0 0 24 24"><path d="M3 6h18v12H3V6Zm2 2v.2l7 4.8 7-4.8V8l-7 4.8L5 8Z" /></svg>
                  </a>
                </div>
              </div>
              <div className="footer-link-group">
                <h4>Quick Links</h4>
                <a href="#home">Home</a>
                <a href="#about">About Us</a>
                <a href="#services">Our Services</a>
                <a href="#airport">Airport Transfers</a>
                <a href="#contact">Contact Us</a>
              </div>
              <div className="footer-link-group">
                <h4>Contact</h4>
                <a className="footer-contact-item" href="mailto:info@taxi-247.co.uk">
                  <span className="footer-contact-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24"><path d="M3 6h18v12H3V6Zm2 2v.2l7 4.8 7-4.8V8l-7 4.8L5 8Z" /></svg>
                  </span>
                  <span>info@taxi-247.co.uk</span>
                </a>
                <a className="footer-contact-item" href="tel:02038393300">
                  <span className="footer-contact-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24"><path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" /></svg>
                  </span>
                  <span>02038393300</span>
                </a>
                <a className="footer-contact-item" href="https://wa.me/447365874733" target="_blank" rel="noopener noreferrer">
                  <span className="footer-contact-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24"><path d="M12.04 2C6.6 2 2.2 6.3 2.2 11.62c0 1.96.6 3.78 1.64 5.3L2 22l5.27-1.73a10.03 10.03 0 0 0 4.77 1.2h.01c5.43 0 9.84-4.3 9.84-9.63C21.89 6.3 17.48 2 12.04 2Z" /></svg>
                  </span>
                  <span>07365874733</span>
                </a>
              </div>
              <div className="footer-link-group">
                <h4>Working Hours</h4>
                <p className="footer-hours-item">
                  <span className="footer-hours-day">Mon – Fri</span>
                  <span className="footer-hours-time">24 / 7</span>
                </p>
                <p className="footer-hours-item">
                  <span className="footer-hours-day">Saturday</span>
                  <span className="footer-hours-time">24 / 7</span>
                </p>
                <p className="footer-hours-item">
                  <span className="footer-hours-day">Sunday</span>
                  <span className="footer-hours-time">24 / 7</span>
                </p>
                <p className="footer-hours-item">
                  <span className="footer-hours-day">Holidays</span>
                  <span className="footer-hours-time">Open</span>
                </p>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="container footer-bottom-inner">
              <p className="copyright">
                © {new Date().getFullYear()} <span className="copyright-brand">TAXI-247</span>. All rights reserved.
              </p>
              <div className="footer-bottom-links">
                <a href="#home">Privacy Policy</a>
                <a href="#home">Terms of Service</a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }

  return (
    <div className="site-shell">
      <header className="site-header">
        <div className="container header-content">
          <a className="brand" href="#home" aria-label="TAXI-247 home">
            {renderBrandLogo()}
          </a>

          <button
            className="menu-toggle"
            type="button"
            onClick={() => setIsMenuOpen((prev) => !prev)}
            aria-expanded={isMenuOpen}
            aria-label="Toggle menu"
          >
            ☰
          </button>

          <nav className={`main-nav ${isMenuOpen ? 'open' : ''}`} aria-label="Main navigation">
            <a href="#home" onClick={() => setIsMenuOpen(false)}>Home</a>
            <a href="#about" onClick={() => setIsMenuOpen(false)}>About Us</a>
            <a href="#services" onClick={() => setIsMenuOpen(false)}>Our Services</a>
            <a href="#airport" onClick={() => setIsMenuOpen(false)}>Airport Transfers</a>
            <a href="#contact" onClick={() => setIsMenuOpen(false)}>Contact Us</a>
          </nav>

          <a className="header-contact-link" href="#contact">Contact Us</a>
        </div>
      </header>

      <main>
        <section className="hero" id="home" style={heroStyle}>
          <div className="hero-overlay" />
          <div className="container hero-content">
            <div className="hero-intro">
              <p className="hero-kicker">Trusted 24/7 Transport Service</p>
              <h1 className="hero-title">Book Reliable Airport Transfers & Rides</h1>
              <p className="hero-subtitle">With TAXI-247, available 24/7.</p>
            </div>
            <div className="quick-actions" role="list">
              {quickActions.map((action) => (
                <a
                  className={`action-card ${action.className}`}
                  href={action.href}
                  key={action.label}
                  role="listitem"
                  target={action.external ? '_blank' : undefined}
                  rel={action.external ? 'noopener noreferrer' : undefined}
                >
                  <span className="action-icon">{action.icon}</span>
                  <span className="action-text">{action.label}</span>
                </a>
              ))}
            </div>
          </div>
        </section>

        {renderExperienceBand('top')}

        <section className="content-section" id="about">
          <div className="container about-layout">
            <div className="about-main">
              <p className="section-tag">About Us</p>
              <h2>About TAXI-247</h2>
              <p className="about-intro">
                TAXI-247 is a trusted provider of minicab services, operating
                24/7 to meet diverse travel needs. With a strong commitment to
                safety and professionalism, our drivers are fully licensed and
                DBS-checked for complete passenger peace of mind.
              </p>
              <p>
                We offer a practical and affordable alternative to Black Cabs,
                with fares up to 35% lower without compromising on quality,
                comfort, or reliability.
              </p>

              <h3>What We Do</h3>
              <p>
                We provide comprehensive transport solutions including local
                trips, airport transfers, and wheelchair-accessible travel. Our
                fleet includes Saloon Cars, Executive Cars, MPVs, and 6 to
                8-seater minibuses to support all group sizes and requirements.
              </p>

              <h3>What We Offer</h3>
              <ul className="about-offer-list">
                <li>24/7 service available day and night</li>
                <li>Fully licensed and DBS-checked drivers</li>
                <li>Wheelchair-accessible vehicle options</li>
                <li>Airport transfers for Heathrow, Gatwick, Stansted, Luton, and London City Airport</li>
                <li>Fast booking via web or call on 02038393300</li>
              </ul>
            </div>

            <div className="about-blocks">
              <article className="about-card">
                <h3>Our Mission</h3>
                <p>
                  To provide safe, reliable, and affordable transportation
                  services through skilled drivers, a modern fleet, and
                  customer-first support for stress-free daily and airport
                  journeys.
                </p>
              </article>
              <article className="about-card">
                <h3>Our Vision</h3>
                <p>
                  To be the most trusted and preferred TAXI-247 service,
                  recognized for safety, affordability, and customer
                  satisfaction while continuously improving booking and travel
                  experiences.
                </p>
              </article>
            </div>
          </div>
        </section>

        <section className="content-section services" id="services">
          <div className="container">
            <p className="section-tag">Our Services</p>
            <h2>What We Offer</h2>
            <p className="services-sub">Professional transport solutions available 24/7 across TAXI-247 and beyond.</p>
            <div className="service-grid-pro">
              {[
                {
                  title: 'Airport Transfers',
                  desc: 'TAXI-247 provides reliable and on-time airport transfer services in Edinburgh, ensuring passengers reach their destination without any stress or delay. TAXI-247 focuses on comfort, punctuality, and smooth travel experience for both arrivals and departures. With professional drivers and well-maintained vehicles, TAXI-247 makes airport journeys easy and dependable.',
                  img: 'Airport Transfers.jpg',
                },
                {
                  title: 'Free Child & Baby Seats',
                  desc: 'TAXI-247 offers free child and baby seat facilities in Edinburgh to ensure safe and secure travel for families with young children. TAXI-247 prioritizes passenger safety by providing properly fitted seats for infants and kids. Families can enjoy comfortable journeys knowing TAXI-247 takes care of their safety needs.',
                  img: 'Free Child & Baby Seats.jpg',
                },
                {
                  title: 'Meet & Greet Service',
                  desc: 'TAXI-247 provides a professional meet & greet service at Edinburgh airport where drivers warmly welcome passengers upon arrival. TAXI-247 assists with luggage handling and guides passengers smoothly to their vehicles. This service ensures a stress-free and welcoming airport experience with TAXI-247.',
                  img: 'Meet & Greet Service.jpg',
                },
                {
                  title: '24/7 Taxi Service',
                  desc: 'TAXI-247 operates a 24/7 taxi service in Edinburgh, allowing passengers to book rides at any time of the day or night. TAXI-247 ensures that transportation is always available, regardless of time or urgency. With round-the-clock service, TAXI-247 provides maximum convenience for all customers.',
                  img: '247 Taxi Service.jfif',
                },
                {
                  title: 'Executive & Business Travel',
                  desc: 'TAXI-247 offers premium executive and business travel services in Edinburgh designed for corporate clients and professionals. TAXI-247 ensures privacy, comfort, and high-quality service for meetings, conferences, and official trips. Business travelers rely on TAXI-247 for a smooth and professional travel experience.',
                  img: 'Executive & Business Travel.webp',
                },
                {
                  title: 'City-to-City Transfers',
                  desc: 'TAXI-247 provides reliable city-to-city transfer services from Edinburgh, making intercity travel simple and comfortable. TAXI-247 ensures safe long-distance journeys with experienced drivers and well-maintained vehicles. Passengers can travel between cities with confidence using TAXI-247.',
                  img: 'City-to-City Transfers.jpg',
                },
                {
                  title: 'Minibus & Group Travel',
                  desc: 'TAXI-247 offers spacious minibus and group travel services in Edinburgh, perfect for families, events, and group tours. TAXI-247 provides comfortable seating and ample space for multiple passengers and luggage. Group travel becomes easy and enjoyable with TAXI-247.',
                  img: 'Minibus & Group Travel.jpg',
                },
                {
                  title: 'Wheelchair Accessible Vehicles',
                  desc: 'TAXI-247 provides wheelchair accessible vehicles in Edinburgh to ensure inclusive and comfortable travel for all passengers. TAXI-247 is committed to supporting passengers with mobility needs through specially designed vehicles. Everyone can travel safely and independently with TAXI-247.',
                  img: 'Wheelchair Accessible.webp',
                },
                {
                  title: 'Pet-Friendly Taxi Service',
                  desc: 'TAXI-247 offers pet-friendly taxi services in Edinburgh, allowing passengers to travel with their pets comfortably. TAXI-247 ensures a safe and relaxed environment for both passengers and their animals. Pet owners can travel without worry using TAXI-247.',
                  img: 'Pet-Friendly Service.jpg',
                },
                {
                  title: 'Courier & Parcel Delivery',
                  desc: 'TAXI-247 provides fast and secure courier and parcel delivery services in Edinburgh for both personal and business needs. TAXI-247 ensures safe handling and timely delivery of packages across the city. Customers trust TAXI-247 for reliable delivery solutions.',
                  img: 'Courier & Parcel Delivery.webp',
                },
                {
                  title: 'Long Distance Journeys',
                  desc: 'TAXI-247 offers long-distance travel services from Edinburgh with comfort and safety as top priorities. TAXI-247 uses experienced drivers to ensure smooth journeys over long routes. Passengers can relax and enjoy stress-free travel with TAXI-247.',
                  img: 'Long Distance Journeys.webp',
                },
                {
                  title: 'Easy Online Booking',
                  desc: 'TAXI-247 provides an easy online booking system in Edinburgh, making ride reservations quick and simple. TAXI-247 allows customers to book taxis within minutes through a user-friendly platform. Convenience and efficiency are the main focus of TAXI-247.',
                  img: 'Easy Online Booking.png',
                },
                {
                  title: 'Secure Online Payments',
                  desc: 'TAXI-247 supports secure online payment options in Edinburgh for safe and hassle-free transactions. TAXI-247 ensures all payments are protected with advanced security systems. Customers can pay confidently using TAXI-247.',
                  img: 'Secure Online Payments.jpg',
                },
                {
                  title: 'Extra Luggage Transfers',
                  desc: 'TAXI-247 accommodates extra luggage in Edinburgh, making travel easier for passengers with heavy or additional baggage. TAXI-247 provides vehicles with sufficient space for all luggage needs. Passengers can travel comfortably without luggage concerns using TAXI-247.',
                  img: 'Extra Luggage Transfers.jpg',
                },
                {
                  title: 'Flight Monitoring & Delay Tracking',
                  desc: 'TAXI-247 offers real-time flight monitoring in Edinburgh to adjust pickup times according to delays or early arrivals. TAXI-247 ensures drivers are always updated with flight schedules for smooth coordination. This service guarantees a stress-free airport pickup experience with TAXI-247.',
                  img: 'Flight Monitoring.jpg',
                },
              ].map((svc) => (
                <article className="svc-card" key={svc.title}>
                  <div className="svc-img-slot">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/${encodeURIComponent(svc.img)}`}
                      alt={svc.title}
                      className="svc-img"
                    />
                  </div>
                  <div className="svc-body">
                    <h3>{svc.title}</h3>
                    <p>{svc.desc}</p>
                    <a
                      className="airport-read-more"
                      href={`#/service-details/${getServiceSlug(svc.title)}`}
                    >
                      {svc.title}
                    </a>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="content-section airport-section" id="airport">
          <div className="container">
            <p className="section-tag">Airport Transfers</p>
            <h2>Reliable Airport Transfers</h2>

            <div className="airport-hero">
              <div className="airport-hero-image-wrap">
                <img
                  src={`${process.env.PUBLIC_URL}/images/Airport%20Transfersslider.jpg`}
                  alt="TAXI-247 airport transfer service"
                  className="airport-hero-image"
                />
              </div>
              <div className="airport-hero-content">
                <p>
                  TAXI-247 provides reliable and professional airport
                  transfer services in Edinburgh, ensuring a smooth and
                  stress-free journey for every passenger. TAXI-247 focuses
                  on punctuality, offering on-time pickups and drop-offs so you
                  never have to worry about missing a flight. With experienced
                  drivers and comfortable vehicles, TAXI-247 guarantees a
                  safe and relaxing travel experience.
                </p>
                <p>
                  Whether you are traveling for business or leisure, TAXI-247
                  Cabs makes airport transportation simple, convenient, and
                  dependable. Additionally, TAXI-247 monitors flight
                  schedules to adjust pickup times according to delays or early
                  arrivals, ensuring maximum convenience for customers.
                </p>
              </div>
            </div>

            <div className="airport-list-grid">
              {AIRPORTS.map((airport) => (
                <article className="airport-item" key={airport.name}>
                  <h3>{airport.name}</h3>
                  <p>{airport.desc}</p>
                  <a
                    className="airport-read-more"
                    href={`#/airport-details/${getAirportSlug(airport.name)}`}
                  >
                    Read More
                  </a>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="content-section contact" id="contact">
          <div className="container">
            <p className="section-tag">Contact Us</p>
            <h2>Have a question or need a custom quote?</h2>
            <div className="contact-panel">
              <div className="contact-primary">
                <div className="contact-call-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24">
                    <path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" />
                  </svg>
                </div>
                <div className="contact-main-copy">
                  <p className="contact-support-line">We are open 24 hours throughout the year.</p>
                  <a className="contact-phone-link" href="tel:02038393300">Call us anytime at 02038393300</a>
                  <p className="contact-note">Fast support for instant booking and custom quotes.</p>
                </div>
              </div>

              <div className="contact-methods">
                <article className="contact-method-card">
                  <span className="contact-method-label">Call</span>
                  <a href="tel:02038393300">02038393300</a>
                </article>
                <article className="contact-method-card">
                  <span className="contact-method-label">Email</span>
                  <a href="mailto:info@taxi-247.co.uk">info@taxi-247.co.uk</a>
                </article>
                <article className="contact-method-card">
                  <span className="contact-method-label">WhatsApp</span>
                  <a href="https://wa.me/447365874733" target="_blank" rel="noopener noreferrer">07365874733</a>
                </article>
                <article className="contact-method-card">
                  <span className="contact-method-label">Address</span>
                  <p>UK</p>
                </article>
              </div>
            </div>
          </div>
        </section>
      </main>

      {renderMobileCallStrip()}

      <div className="floating-contact" aria-label="Quick contact actions">
        <a
          className="floating-btn floating-whatsapp"
          href="https://wa.me/447365874733"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12.04 2C6.6 2 2.2 6.3 2.2 11.62c0 1.96.6 3.78 1.64 5.3L2 22l5.27-1.73a10.03 10.03 0 0 0 4.77 1.2h.01c5.43 0 9.84-4.3 9.84-9.63C21.89 6.3 17.48 2 12.04 2Zm0 17.63c-1.5 0-2.98-.4-4.26-1.17l-.3-.18-3.13 1.03 1.03-3.03-.2-.31a7.53 7.53 0 0 1-1.2-4.05c0-4.17 3.47-7.57 7.75-7.57 4.27 0 7.75 3.4 7.75 7.57 0 4.18-3.47 7.57-7.74 7.57Zm4.14-5.66c-.22-.1-1.31-.64-1.52-.71-.2-.08-.35-.1-.5.1-.15.22-.58.7-.7.84-.13.16-.26.18-.48.06-.22-.1-.94-.34-1.78-1.08-.66-.58-1.1-1.3-1.23-1.52-.13-.22-.01-.33.1-.44.1-.1.22-.26.33-.39.11-.12.15-.22.23-.36.08-.16.03-.28-.02-.4-.05-.1-.5-1.2-.68-1.65-.18-.42-.36-.36-.5-.37h-.43c-.15 0-.39.06-.59.28-.2.22-.78.76-.78 1.85 0 1.1.8 2.15.92 2.3.11.14 1.55 2.44 3.86 3.32.55.24.98.39 1.31.5.55.18 1.04.16 1.43.1.43-.06 1.31-.53 1.5-1.04.2-.5.2-.94.14-1.04-.06-.1-.2-.16-.43-.26Z" />
          </svg>
        </a>
        <a
          className="floating-btn floating-call"
          href="tel:+442038393300"
          aria-label="Call now"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" />
          </svg>
        </a>
      </div>

      <footer className="site-footer">
        <div className="footer-top">
          <div className="container footer-grid">
            <div className="footer-brand-block">
              <a className="brand footer-brand-link" href="#home" aria-label="TAXI-247 home">
                {renderBrandLogo(true)}
              </a>
              <p>
                Professional taxi and airport transfer service focused on safety,
                punctuality, and comfort.
              </p>
              <div className="footer-social-row">
                <a className="footer-social-btn" href="tel:02038393300" aria-label="Call us">
                  <svg viewBox="0 0 24 24"><path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" /></svg>
                </a>
                <a className="footer-social-btn" href="https://wa.me/447365874733" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                  <svg viewBox="0 0 24 24"><path d="M12.04 2C6.6 2 2.2 6.3 2.2 11.62c0 1.96.6 3.78 1.64 5.3L2 22l5.27-1.73a10.03 10.03 0 0 0 4.77 1.2h.01c5.43 0 9.84-4.3 9.84-9.63C21.89 6.3 17.48 2 12.04 2Z" /></svg>
                </a>
                <a className="footer-social-btn" href="mailto:info@taxi-247.co.uk" aria-label="Email us">
                  <svg viewBox="0 0 24 24"><path d="M3 6h18v12H3V6Zm2 2v.2l7 4.8 7-4.8V8l-7 4.8L5 8Z" /></svg>
                </a>
              </div>
            </div>
            <div className="footer-link-group">
              <h4>Quick Links</h4>
              <a href="#home">Home</a>
              <a href="#about">About Us</a>
              <a href="#services">Our Services</a>
              <a href="#airport">Airport Transfers</a>
              <a href="#contact">Contact Us</a>
            </div>
            <div className="footer-link-group">
              <h4>Contact</h4>
              <a className="footer-contact-item" href="mailto:info@taxi-247.co.uk">
                <span className="footer-contact-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24">
                    <path d="M3 6h18v12H3V6Zm2 2v.2l7 4.8 7-4.8V8l-7 4.8L5 8Z" />
                  </svg>
                </span>
                <span>info@taxi-247.co.uk</span>
              </a>
              <a className="footer-contact-item" href="tel:02038393300">
                <span className="footer-contact-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24">
                    <path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" />
                  </svg>
                </span>
                <span>02038393300</span>
              </a>
              <a className="footer-contact-item" href="https://wa.me/447365874733" target="_blank" rel="noopener noreferrer">
                <span className="footer-contact-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24">
                    <path d="M12.04 2C6.6 2 2.2 6.3 2.2 11.62c0 1.96.6 3.78 1.64 5.3L2 22l5.27-1.73a10.03 10.03 0 0 0 4.77 1.2h.01c5.43 0 9.84-4.3 9.84-9.63C21.89 6.3 17.48 2 12.04 2Z" />
                  </svg>
                </span>
                <span>07365874733</span>
              </a>
            </div>
            <div className="footer-link-group">
              <h4>Working Hours</h4>
              <p className="footer-hours-item">
                <span className="footer-hours-day">Mon – Fri</span>
                <span className="footer-hours-time">24 / 7</span>
              </p>
              <p className="footer-hours-item">
                <span className="footer-hours-day">Saturday</span>
                <span className="footer-hours-time">24 / 7</span>
              </p>
              <p className="footer-hours-item">
                <span className="footer-hours-day">Sunday</span>
                <span className="footer-hours-time">24 / 7</span>
              </p>
              <p className="footer-hours-item">
                <span className="footer-hours-day">Holidays</span>
                <span className="footer-hours-time">Open</span>
              </p>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container footer-bottom-inner">
            <p className="copyright">
              © {new Date().getFullYear()} <span className="copyright-brand">TAXI-247</span>. All rights reserved.
            </p>
            <div className="footer-bottom-links">
              <a href="#home">Privacy Policy</a>
              <a href="#home">Terms of Service</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
